import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './assets/css/style.css'
import './assets/css/tech-pages.css'
import './assets/js/script.js'
import './assets/fontIcon/css/all.min.css'
import Router from './route/Router';
import { ParallaxProvider } from 'react-scroll-parallax';
import { ToastContainer } from 'react-toastify';

function App() {

  return (
    <ParallaxProvider>
      <div className="wrapper">
        <ToastContainer position="top-right" autoClose={4000} />

        <Router />
      </div>
    </ParallaxProvider>
  );
}

export default App;
